// index.js or main entry file
import React from 'react';
import ReactDOM from 'react-dom';
import Tabs from './Tabs';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <Tabs />
  </React.StrictMode>,
  document.getElementById('root')
);